import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_download.svg'
import _imports_1 from '@/app/ui/assets/svg/x-gray.svg'
import _imports_2 from '@/app/ui/assets/svg/chevron-prev.svg'
import _imports_3 from '@/app/ui/assets/svg/chevron-next.svg'


const _hoisted_1 = { class: "fixed inset-0 z-50 flex items-center justify-center bg-black-lp-50" }
const _hoisted_2 = { class: "relative bg-white rounded-lg w-700px" }
const _hoisted_3 = { class: "flex items-center justify-between p-4 border-b border-gray-lp-1300" }
const _hoisted_4 = { class: " text-base text-gray-lp-300 font-semibold" }
const _hoisted_5 = { class: "flex items-center gap-4" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5 h-5",
  alt: "download"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-100 font-semibold text-14px border-b border-red-lp-100" }, "Download", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5 h-5",
  alt: "close"
}, null, -1)
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = { class: "flex items-center justify-center p-4" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-6 h-6",
  alt: "previous"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "w-6 h-6",
  alt: "next"
}, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "flex justify-center gap-1 pb-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("h3", _hoisted_4, _toDisplayString(_ctx.title), 1),
        _createVNode("div", _hoisted_5, [
          _createVNode("button", {
            class: "flex flex-row space-x-1 items-center cursor-pointer",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleDownload && _ctx.handleDownload(...args)))
          }, [
            _hoisted_6,
            _hoisted_7
          ]),
          _createVNode("button", {
            id: "button_close_image_preview",
            class: "text-gray-500 hover:text-gray-700",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
          }, [
            _hoisted_8
          ])
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          (_ctx.isVideo(_ctx.images[_ctx.currentIndex]))
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                (_ctx.isAllowedVideo(_ctx.images[_ctx.currentIndex]))
                  ? (_openBlock(), _createBlock("video", {
                      key: 0,
                      src: _ctx.images[_ctx.currentIndex],
                      class: "h-80 object-cover rounded-xl w-full",
                      controls: ""
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createBlock("img", {
                key: 1,
                src: _ctx.images[_ctx.currentIndex],
                class: "h-80 object-cover rounded-xl w-full",
                alt: "preview"
              }, null, 8, ["src"]))
        ]),
        _withDirectives(_createVNode("button", {
          id: "button_prev_image_preview",
          class: "absolute left-0 top-1/2 -translate-y-1/2 bg-white rounded-full p-2 shadow-md",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.previousImage && _ctx.previousImage(...args))),
          disabled: _ctx.currentIndex === 0
        }, [
          _hoisted_11
        ], 8, ["disabled"]), [
          [_vShow, _ctx.images.length > 1]
        ]),
        _withDirectives(_createVNode("button", {
          id: "button_next_image_preview",
          class: "absolute right-0 top-1/2 -translate-y-1/2 bg-white rounded-full p-2 shadow-md",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.nextImage && _ctx.nextImage(...args))),
          disabled: _ctx.currentIndex === _ctx.images.length - 1
        }, [
          _hoisted_12
        ], 8, ["disabled"]), [
          [_vShow, _ctx.images.length > 1]
        ])
      ]),
      (_ctx.images.length > 1)
        ? (_openBlock(), _createBlock("div", _hoisted_13, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.images, (_, index) => {
              return (_openBlock(), _createBlock("button", {
                key: index,
                class: ["w-2 h-2 rounded-full", index === _ctx.currentIndex ? 'bg-red-lp-100' : 'bg-gray-lp-1400'],
                onClick: ($event: any) => (_ctx.currentIndex = index)
              }, null, 10, ["onClick"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}